"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parse;

var _url = _interopRequireDefault(require("url"));

var _querystring = _interopRequireDefault(require("querystring"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      base = _ref.base,
      fragment = _ref.fragment,
      params = _ref.params;

  var combinedUrl = _url["default"].resolve(base, fragment);

  var parsedUrl = _url["default"].parse(combinedUrl);

  var query = _querystring["default"].parse(parsedUrl.query);

  parsedUrl.search = _querystring["default"].encode(_objectSpread({}, query, {}, params));
  return _url["default"].format(parsedUrl);
}